// extracted by mini-css-extract-plugin
export default {"container":"ChoiceContainer_container__HZXHM","container--hidden":"ChoiceContainer_container--hidden__nm9ge"};